var _g, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgInactive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.97,12.71c1.81-1.25,3-3.33,3-5.69c0-3.8-3.1-6.9-6.9-6.9s-6.9,3.1-6.9,6.9c0,2.36,1.19,4.44,3,5.69 c-1.69,0.58-3.24,1.54-4.54,2.85c-2.25,2.25-3.5,5.25-3.5,8.44h1.87c0-5.55,4.52-10.07,10.07-10.07c0.38,0,1.6,0.24,1.94,0.07  M12.06,12.06c-2.78,0-5.04-2.26-5.04-5.04s2.26-5.04,5.04-5.04s5.04,2.26,5.04,5.04S14.84,12.06,12.06,12.06z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.52,14.35c-2.47,0-4.48,2.01-4.48,4.48s2.01,4.48,4.48,4.48S22,21.3,22,18.83S19.99,14.35,17.52,14.35z M17.52,22.31 c-1.92,0-3.48-1.56-3.48-3.48s1.56-3.48,3.48-3.48S21,16.91,21,18.83S19.44,22.31,17.52,22.31L17.52,22.31z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.74,16.74h-0.63v2.28L19.09,21l0.45-0.45l-1.8-1.8V16.74z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInactive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Inactive.700efc19.svg";
export { ForwardRef as ReactComponent };